module.exports = __webpack_public_path__ + "static/media/pauseButton.979dee7a.svg";